import { render, staticRenderFns } from "./TranslucentModal.vue?vue&type=template&id=becf800e&scoped=true"
import script from "./TranslucentModal.vue?vue&type=script&lang=js"
export * from "./TranslucentModal.vue?vue&type=script&lang=js"
import style0 from "./TranslucentModal.vue?vue&type=style&index=0&id=becf800e&prod&scoped=true&lang=css"
import style1 from "./TranslucentModal.vue?vue&type=style&index=1&id=becf800e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becf800e",
  null
  
)

export default component.exports